export default {
  manual: 'Manuaalinen',
  filters: {
    status: 'Tila',
    event_type: 'Tapahtumatyyppi',
  },
  columns: {
    event: 'Tapahtuma',
    status: 'Tila',
    attempts: 'Yritykset',
    last_http_status: 'Viimeisin HTTP-tila',
    created_at: 'Luotu',
  },
  statuses: {
    pending: 'Odottaa',
    delivered: 'Toimitettu',
    failed: 'Epäonnistui',
  },
  buttons: {
    details: 'Tiedot',
    resend: 'Lähetä uudelleen',
  },
  detail: {
    title: 'Toimituksen tiedot',
    event: 'Tapahtuma',
    attempts: 'Yritykset',
    no_attempts: 'Ei vielä yrityksiä.',
    no_response: 'ei vastausta',
    payload: 'Hyötykuorma',
  },
  toasts: {
    load_error: 'Toimituksia ei voitu ladata.',
    resend_error: 'Toimitusta ei voitu lähettää uudelleen.',
    resent: 'Toimitus jonossa uudelleenlähetykseen.',
  },
};
